import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Breadcrumb, Typography } from "antd";
import about1 from "../../../Assets/PNG/about1.webp";
import about2 from "../../../Assets/PNG/about2.webp";
import about3 from "../../../Assets/PNG/about3.webp";
import about from "../../../Assets/PNG/about.jpg";

const { Title } = Typography;

const GOLD = "#C5A028";
const INK = "#111";
const BODY = "#444";

// Inline styles match the rest of the customer-site theme (breadcrumb bar
// → white-on-desktop / black-on-mobile page header with gold eyebrow +
// gradient rule), exactly as About / Contact / RetailerQuery do.
const styles = `
  .cf-page { background: #fff; color: #1a1a1a; padding: 0 0 90px; font-family: "Poppins", sans-serif; }

  /* ── Breadcrumb bar ─────────────────────────────────────── */
  .cf-bcBar { background: #f7f7f7; border-bottom: 1px solid #eee; padding: 16px 0; text-align: center; }
  .cf-bcInner { max-width: 1400px; margin: 0 auto; padding: 0 40px; }
  .cf-bcInner :global(.ant-breadcrumb), .cf-bcInner .ant-breadcrumb { font-size: 12px; font-weight: 500; letter-spacing: 0.3px; }
  @media (max-width: 768px) { .cf-bcInner { padding: 0 16px; } }

  /* ── Page header (white desktop / black mobile, mirroring About) ── */
  .cf-header { text-align: center; padding: 50px 20px 40px; }
  @media (max-width: 991px) { .cf-header { background: #111; padding: 36px 20px 32px; } }
  .cf-eyebrow { display: block; font-size: 11px; font-weight: 600; letter-spacing: 4px; text-transform: uppercase; color: ${GOLD}; margin-bottom: 12px; }
  .cf-pageTitle { font-size: 32px !important; font-weight: 700 !important; letter-spacing: 3px; text-transform: uppercase; color: #111 !important; margin: 0 0 18px !important; border: none !important; }
  @media (max-width: 991px) { .cf-pageTitle { color: #fff !important; } }
  @media (max-width: 425px) { .cf-pageTitle { font-size: 24px !important; letter-spacing: 2px; } }
  .cf-headingLine { width: 50px; height: 2px; background: linear-gradient(90deg, transparent, ${GOLD}, #D4AF37, ${GOLD}, transparent); margin: 0 auto; }
  @media (max-width: 991px) { .cf-headingLine { display: none; } }

  /* ── Body ─────────────────────────────────────────────── */
  .cf-h2 { font-size: 28px; letter-spacing: 2px; text-transform: uppercase; font-weight: 700; color: ${INK}; line-height: 1.2; margin: 0 0 18px; }
  .cf-body { font-size: 15px; line-height: 1.85; color: ${BODY}; font-weight: 300; }
  .cf-rule { width: 60px; height: 2px; background: ${GOLD}; margin: 0 auto; }
  .cf-rule-left { width: 60px; height: 2px; background: ${GOLD}; margin: 18px 0 22px; }

  .cf-section { max-width: 1180px; margin: 0 auto; padding: 80px 24px; }
  .cf-row { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  .cf-row.reverse { direction: rtl; }
  .cf-row.reverse > * { direction: ltr; }

  .cf-img { width: 100%; aspect-ratio: 4/5; background-size: cover; background-position: center; }
  .cf-img-wide { width: 100%; aspect-ratio: 16/10; background-size: cover; background-position: center; }

  /* Process strip — dark band */
  .cf-process { background: #0a0a0a; color: #fff; padding: 80px 24px; }
  .cf-process-inner { max-width: 1180px; margin: 0 auto; }
  .cf-process-head { text-align: center; margin-bottom: 56px; }
  .cf-process-head .cf-h2 { color: #fff; }
  .cf-steps { display: grid; grid-template-columns: repeat(5, 1fr); gap: 28px; }
  .cf-step { text-align: center; }
  .cf-step-num { font-size: 12px; letter-spacing: 4px; color: ${GOLD}; font-weight: 600; margin-bottom: 14px; }
  .cf-step-title { font-size: 15px; letter-spacing: 2px; text-transform: uppercase; font-weight: 600; color: #fff; margin-bottom: 12px; }
  .cf-step-text { font-size: 13px; line-height: 1.7; color: #aaa; font-weight: 300; }

  .cf-quote { padding: 110px 24px; text-align: center; background: #fafaf6; }
  .cf-quote-text { font-size: 26px; line-height: 1.6; color: ${INK}; font-weight: 300; max-width: 760px; margin: 0 auto; font-style: italic; letter-spacing: 0.4px; }
  .cf-quote-rule { width: 80px; height: 1px; background: ${GOLD}; margin: 28px auto; }

  .cf-cta { padding: 90px 24px; text-align: center; }
  .cf-cta-btn { display: inline-block; padding: 16px 44px; background: ${INK}; color: #fff; font-size: 12px; letter-spacing: 3px; font-weight: 600; text-transform: uppercase; cursor: pointer; border: none; font-family: inherit; transition: background 0.25s ease, transform 0.25s ease; }
  .cf-cta-btn:hover { background: ${GOLD}; transform: translateY(-2px); }

  @media (max-width: 991px) {
    .cf-section { padding: 60px 18px; }
    .cf-row { grid-template-columns: 1fr; gap: 30px; }
    .cf-row.reverse { direction: ltr; }
    .cf-h2 { font-size: 22px; }
    .cf-steps { grid-template-columns: repeat(2, 1fr); gap: 32px; }
    .cf-process { padding: 56px 18px; }
    .cf-quote { padding: 70px 18px; }
    .cf-quote-text { font-size: 18px; }
    .cf-cta { padding: 60px 18px; }
  }
  @media (max-width: 480px) {
    .cf-steps { grid-template-columns: 1fr; gap: 28px; }
  }
  @media (max-width: 900px) { .cf-innovation-grid { grid-template-columns: 1fr !important; gap: 36px !important; } }
`;

function Craftsmanship() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="cf-page">
      <style>{styles}</style>

      {/* Breadcrumb */}
      <div className="cf-bcBar">
        <div className="cf-bcInner">
          <Breadcrumb
            items={[
              { title: <Link to="/" style={{ color: "#666", textDecoration: "none" }}>Home</Link> },
              { title: "Craftsmanship" },
            ]}
          />
        </div>
      </div>

      {/* Page header — matches About / Contact pattern (black on mobile) */}
      <div className="cf-header">
        <span className="cf-eyebrow">The Diamond Counter</span>
        <Title level={2} className="cf-pageTitle">Craftsmanship</Title>
        <div className="cf-headingLine" />
      </div>

      {/* ── Heritage of Skill ─────────────────────────────────── */}
      <section className="cf-section">
        <div className="cf-row">
          <div className="cf-img" style={{ backgroundImage: `url(${about1})` }} aria-hidden="true" />
          <div>
            <span className="cf-eyebrow">Section One</span>
            <h2 className="cf-h2" style={{ marginTop: 12 }}>Heritage of Skill</h2>
            <div className="cf-rule-left" />
            <p className="cf-body">
              For generations, fine jewellery has been defined by the hands that shape it. Our artisans draw
              upon traditional techniques that honour this heritage, preserving the artistry and discipline at
              the heart of exceptional craftsmanship.
            </p>
          </div>
        </div>
      </section>

      {/* ── Workshop Sequence (5 steps) ───────────────────────── */}
      <section className="cf-process">
        <div className="cf-process-inner">
          <div className="cf-process-head">
            <span className="cf-eyebrow">From sketch to signature</span>
            <h2 className="cf-h2" style={{ marginTop: 12 }}>The Workshop Sequence</h2>
            <div className="cf-rule" />
          </div>
          <div className="cf-steps">
            <div className="cf-step">
              <div className="cf-step-num">01</div>
              <div className="cf-step-title">Design</div>
              <p className="cf-step-text">A drawing becomes a CAD, refined until every proportion sits in perfect balance.</p>
            </div>
            <div className="cf-step">
              <div className="cf-step-num">02</div>
              <div className="cf-step-title">Filing</div>
              <p className="cf-step-text">Cast metal is filed by hand to true the form — edges trued, contours brought to life.</p>
            </div>
            <div className="cf-step">
              <div className="cf-step-num">03</div>
              <div className="cf-step-title">Setting</div>
              <p className="cf-step-text">Stones are placed by hand under magnification — secured, levelled and aligned.</p>
            </div>
            <div className="cf-step">
              <div className="cf-step-num">04</div>
              <div className="cf-step-title">Finish</div>
              <p className="cf-step-text">Surfaces are sanded and polished by hand to bring out depth, lustre and weight.</p>
            </div>
            <div className="cf-step">
              <div className="cf-step-num">05</div>
              <div className="cf-step-title">Sign</div>
              <p className="cf-step-text">Each piece is inspected, approved and signed off by the goldsmith who completed it.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Artistry in Every Detail ──────────────────────────── */}
      <section className="cf-section">
        <div className="cf-row reverse">
          <div className="cf-img" style={{ backgroundImage: `url(${about2})` }} aria-hidden="true" />
          <div>
            <span className="cf-eyebrow">Section Two</span>
            <h2 className="cf-h2" style={{ marginTop: 12 }}>Artistry in Every Detail</h2>
            <div className="cf-rule-left" />
            <p className="cf-body">
              From the first sketch to the final polish, each stage of creation is guided by care and precision.
              Stones are carefully set, metals are finely finished, and every design is considered not only for
              beauty, but for balance and wearability.
            </p>
          </div>
        </div>
      </section>

      {/* ── Innovation Meets Tradition (dark band) ────────────── */}
      <section style={{ background: "#0a0a0a", color: "#fff", padding: "100px 24px" }}>
        <div style={{ maxWidth: 1180, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 56 }}>
            <span className="cf-eyebrow">Section Three</span>
            <h2 className="cf-h2" style={{ marginTop: 12, color: "#fff" }}>Innovation Meets Tradition</h2>
            <div className="cf-rule" />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 64, alignItems: "start" }} className="cf-innovation-grid">
            <div>
              <div style={{ fontSize: 11, letterSpacing: 3, color: GOLD, fontWeight: 600, textTransform: "uppercase", marginBottom: 12 }}>Tradition</div>
              <div style={{ fontSize: 13, lineHeight: 1.85, color: "#aaa", fontWeight: 300 }}>
                Hand-piercing, lost-wax casting, hand-setting under loupe — the slow disciplines that have
                shaped fine jewellery for centuries are still where every piece begins for us.
              </div>
            </div>
            <div>
              <div style={{ fontSize: 11, letterSpacing: 3, color: GOLD, fontWeight: 600, textTransform: "uppercase", marginBottom: 12 }}>Innovation</div>
              <div style={{ fontSize: 13, lineHeight: 1.85, color: "#aaa", fontWeight: 300 }}>
                CAD modelling, laser welding and high-precision casting let us pursue ideas that older tools
                couldn't reach — without ever stepping away from the human hand at the bench.
              </div>
            </div>
          </div>
          <p className="cf-body" style={{ color: "#bbb", textAlign: "center", maxWidth: 800, margin: "56px auto 0", fontSize: 15 }}>
            While we remain rooted in time-honoured methods, we embrace modern innovation to refine our work.
            This harmony of tradition and technology allows us to achieve consistency, integrity, and designs
            that feel both timeless and contemporary.
          </p>
        </div>
      </section>

      {/* Wide image break */}
      <section>
        <div className="cf-img-wide" style={{ backgroundImage: `url(${about})` }} aria-hidden="true" />
      </section>

      {/* ── A Lasting Promise (quote) ─────────────────────────── */}
      <section className="cf-quote">
        <span className="cf-eyebrow">A Lasting Promise</span>
        <div className="cf-quote-rule" />
        <p className="cf-quote-text">
          “Each piece we craft carries with it a quiet promise: that beauty should endure. It is this
          dedication — to detail, to artistry, to the pursuit of excellence — that defines our craftsmanship.”
        </p>
        <div className="cf-quote-rule" />
        <span className="cf-eyebrow" style={{ color: "#999" }}>The Diamond Counter</span>
      </section>

      {/* CTA */}
      <section className="cf-cta">
        <span className="cf-eyebrow">See it for yourself</span>
        <h2 className="cf-h2" style={{ marginTop: 14, marginBottom: 10 }}>Discover the Collection</h2>
        <div className="cf-rule" style={{ marginBottom: 32 }} />
        <button className="cf-cta-btn" onClick={() => navigate("/product/all")}>Shop All</button>
      </section>
    </div>
  );
}

export default Craftsmanship;
